import { WA_BLACK, WA_TRANSPARANT } from '@constants';
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_SINGLE_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title',
  },
  CONTENT: {
    name: 'content',
    label: 'Add HTML:',
    rules: [{ required: true, message: 'HTML is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the page URL',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  URL_TEXT: {
    name: 'urlText',
    label: 'URL Text:',
    placeholder: 'Enter the text that redirects to URL',
  },
  IMAGE: {
    name: 'image',
    label: 'Image:',
    buttonText: 'CHOOSE A NEW IMAGE',
    size: IMAGE_SIZE['544x360'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
};

export const FORM_FIELD = {
  LEFT_CHILD: {
    name: 'leftTextBlock',
    ...Object.values(FORM_SINGLE_FIELD).map((field) => ({ ...field, name: ['leftTextBlock', field.name] })),
  },
  RIGHT_CHILD: {
    name: 'rightTextBlock',
    ...Object.values(FORM_SINGLE_FIELD).map((field) => ({ ...field, name: ['rightTextBlock', field.name] })),
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK, WA_TRANSPARANT],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.BACKGROUND_COLOUR.name]: '',
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
